import { useKeycloak } from '@react-keycloak/web';
import Loader from 'components/Common/Loader';
import React from 'react';
import { useLocation, Navigate } from 'react-router-dom';

const PrivateRoute: React.FC<{ Component: React.FC }> = (props) => {
  const { Component } = props;
  const { keycloak, initialized } = useKeycloak();
  const location = useLocation();

  if (!initialized) {
    return <Loader />;
  }

  if (!keycloak.authenticated) {
    return <Navigate to="/login" state={{ from: location }} />;
  }

  return <Component />;
};

export default PrivateRoute;
